import { SkillCategory } from '../types';

export const skillCategories: SkillCategory[] = [
  {
    id: 'ai',
    name: 'الذكاء الاصطناعي وهندسته',
    icon: '🧠',
    skills: [
      'LLM',
      'RAG',
      'أنظمة RAG المحلية',
      'On-Premise AI',
      'بنية GPU',
      'n8n',
      'وكلاء الذكاء الاصطناعي',
      'تطبيقات LLM',
      'أتمتة الذكاء الاصطناعي',
      'هندسة أنظمة الذكاء الاصطناعي',
    ],
  },
  {
    id: 'mobile',
    name: 'الموبايل',
    icon: '📱',
    skills: [
      'React Native',
      'React',
      'Android',
      'iOS',
      'هندسة الموبايل',
      'أمان الموبايل',
      'الإشعارات',
      'Firebase',
    ],
  },
  {
    id: 'backend',
    name: 'الخلفية',
    icon: '⚙️',
    skills: [
      'NestJS',
      'PHP',
      'Yii2',
      'REST APIs',
      'MySQL',
      'Firebase',
      'هندسة الخلفية',
    ],
  },
  {
    id: 'web',
    name: 'الويب',
    icon: '🌐',
    skills: [
      'React',
      'JavaScript / TypeScript',
      'تطبيقات ويب متجاوبة',
      'لوحات تحكم إدارية',
    ],
  },
  {
    id: 'devops',
    name: 'DevOps / البنية التحتية',
    icon: '🔧',
    skills: [
      'Docker',
      'linux',
      "shell",
      "git",
      "CI/CD",
    ],
  },
];

export const careerJourney = [
  'مهندس Java',
  'مطور موبايل',
  'مطور خلفية',
  'مستشار موبايل',
  'مهندس موبايل أول',
  'Full-Stack / باني منتجات',
  'مهندس ذكاء اصطناعي',
];
